import React from "react";
import { object, number, string } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card4.m.css";

const StoryCard4 = ({ story, headerType, id, headerLevel }) => {
  if (!story) return null;

  return (
    <div className="story-card story-card-4" styleName="story-card-4" id="story-card-4">
      <Link href={`/${story.slug}`} className="headline-link">
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          width={20}
          height={20}
          id={id}
          lineClamp={2}
        />
      </Link>
      <div>
        <StoryDate story={story} />
      </div>
    </div>
  );
};

StoryCard4.defaultProps = {
  headerType: 2,
  headerLevel: 2,
  showRedDot: false
};

StoryCard4.propTypes = {
  story: object.isRequired,
  headerType: number,
  headerLevel: number,
  id: string,
  pageType: string
};

export default StoryCard4;
